import React, { useEffect, useContext, useState, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";
import { appLogger, Http } from "../../../src/utils";
import Link from "@mui/material/Link";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import Popup from "./popup";

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  SelectChangeEvent,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { UserLoginInfo } from "../../types/context";
import ProductVersionDropdown from "../../components/common/ProductVersionDropdown";
import { getDateString } from "../../utils/data/datetime";
import { apiChatUrl } from "../../utils/config/host-urls";

interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Reports = (props: any) => {
  const navigate = useNavigate();
  const { snackbarShowMessage } = props;
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [productResponse, setProductResponse] = React.useState([] as any);
  const getLocation: any = useLocation();
  const [reportValue, setReportValue] = useState({} as any);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const handleBackButton = () => {
    const stateObj = {
      pageType: getLocation?.state?.tabType || "",
    };
    navigate("/dashboard", { state: stateObj });
  };

  const mapProVerData = (ticketProductdata: any) => {
    const tempData = {
      value: ticketProductdata.productId,
      title: ticketProductdata.name,
      version: ticketProductdata.productVersion,
      proversion: ticketProductdata.name + ticketProductdata.productVersion,
    };
    return tempData;
  };

  const selectedProVerDataFn = (selectedProVerData: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    let tempUserData = {};
    if (tempUserData) {
      tempUserData = {
        ...reportValue,
        productId: selectedProVerData.value,
        productVersion: selectedProVerData.version,
        name: selectedProVerData.title,
      };
    }
    setReportValue(tempUserData);
  };

  const [accountAndVersion, setAccountAndVersion] = useState("");
  const selectAccountAndVersion = (event: SelectChangeEvent) => {
    setAccountAndVersion((event.target as HTMLInputElement).value);
  };

  const [sampleSize, setSampleSize] = useState("");
  const selectSampleSize = (event: SelectChangeEvent) => {
    setSampleSize((event.target as HTMLInputElement).value);
  };

  const [reportType, setReportType] = useState("");
  const selectReportType = (event: SelectChangeEvent) => {
    setReportType((event.target as HTMLInputElement).value);
  };
  const currDate = new Date();
  const stDate = new Date(currDate);
  stDate.setHours(0, 0, 0, 0);
  currDate.setHours(23, 59, 59, 999);
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";

  stDate.setMonth(currDate.getMonth() - 1);
  stDate.setDate(stDate.getDate() + 1);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }
  const [startDateValue, setStartDateValue] = React.useState(stDateTimestamp);
  const [endDateValue, setEndDateValue] = React.useState(currDateTimestamp);

  const changeStartDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(0, 0, 0, 0);
    const timestamp = dt.getTime();
    setStartDateValue(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
    }
  };

  const changeEndDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(23, 59, 59, 999);
    const timestamp = dt.getTime();
    setEndDateValue(timestamp);

    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
  };
  const popupStyles: React.CSSProperties = {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.5s ease-in-out",
    zIndex: 1000,
  };

  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [bgColor, setBgColor] = useState<string>("white");
  const userOrgId = localStorage.getItem("userOrgId");
  const validateMandatoryFields = () => {
    if (!reportValue || Object.keys(reportValue).length < 1) {
      snackbarShowMessage("Please select a account", "error", 3000);
      return false;
    }
    if (!sampleSize) {
      snackbarShowMessage("Please provide Sample Size", "error", 3000);
      return false;
    }
    if (!reportType) {
      snackbarShowMessage("Please provide report type", "error", 3000);
      return false;
    }
    return true;
  };

  const togglePopup = () => {
    if (!showPopup) {
      // alert(accountAndVersion)
      // alert(sampleSize)
      // alert(reportType)
      const validation = validateMandatoryFields();
      if (validation) {
        setLoading(true);
        // Simulate an asynchronous operation (e.g., API call) using setTimeout
        setTimeout(() => {
          setLoading(false);
          setShowPopup(!showPopup);
        }, 1300); // Set loading back to false after 2 seconds (adjust as needed)
      }
    } else {
      setShowPopup(!showPopup);
    }
  };

  const generateAccuracyReport = async () => {
    try {
      const response = await fetch(`${apiChatUrl}/accuracy-report`, {
        method: "POST",
        // Adding body or contents to send
        body: JSON.stringify({
          product_id: reportValue.productId,
          product_version: reportValue.productVersion,
          org_id: userOrgId,
          "email": userInfo.userDetails?.emailId,
          "user_name":
            userInfo.userDetails?.nameFirst && userInfo.userDetails?.nameLast
              ? userInfo.userDetails?.nameFirst + userInfo.userDetails?.nameLast
                ? userInfo.userDetails?.nameFirst
                : userInfo.userDetails?.nameFirst
              : "",
          "start_time": startDateValue,
          "end_time": endDateValue,
          "sample_count": sampleSize,
        }),
        // Adding headers to the request
        headers: {
          "Content-Type": "application/json",
        },
      }) // Converting to JSON
        .then((response: any) => response.json())
        // Displaying results to console
        .then((json: any) => {
          if (json.response === "success") {
            snackbarShowMessage(
              "Your Data will be shared in Email",
              "success",
              3000
            );
          } else {
            snackbarShowMessage("No data found", "error", 3000);
          }
        })
        .catch((error) => {
          snackbarShowMessage(error, "error", 3000);
        });
    } catch (error) {
      snackbarShowMessage(error, "error", 3000);
    }
  };

  const handleCalculateCostAccuracyReport = async () => {
    setShowPopup(!showPopup);
    setLoading(true);
    await generateAccuracyReport();
    setLoading(false);
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          setLoading(false);
        });
    }
  }, []);

  return (
    <div className="product-wrap">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="product tab">
          <Tab label="Accuracy Report" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Box
          display="flex"
          flexDirection="column"
          className="platform-card-container-accuracy"
        >
          <Box
            display="flex"
            justifyContent="end"
            sx={{
              flex: 1,
              backgroundColor: "transparent",
            }}
          ></Box>
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              marginBottom: "0px",
              marginTop: "0px",
              marginLeft: "5px",
            }}
          ></Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="left"
            sx={{
              height: "58px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              Accuracy Report
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            sx={{
              height: "40px",
              marginLeft: "5px",
              marginTop: "7px",
              width: "96%",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
                <Box>
                  <FormControl className="custom-select" fullWidth>
                    <ProductVersionDropdown
                      productResponse={productResponse}
                      selectedProVerData={mapProVerData(reportValue)}
                      selectedProVerDataFn={(value: any) =>
                        selectedProVerDataFn(value)
                      }
                      contextProVersion={mapProVerData(reportValue)}
                      type="cuvo-user-page"
                      labelId="account-select"
                      id="account-select"
                      label="accountSelect"
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel
                      className={!showPopup ? "input-long" : "input-short"}
                    >
                      Sample Size
                      <div style={{ display: "inline-block", color: "red" }}>
                        *
                      </div>
                    </InputLabel>
                    <Select
                      labelId="role-select"
                      id="role-select"
                      label="Role"
                      style={{ minHeight: "37px" }}
                      onChange={selectSampleSize}
                      value={sampleSize}
                    >
                      <MenuItem key="1" value="10">
                        10
                      </MenuItem>
                      <MenuItem key="2" value="50">
                        50
                      </MenuItem>
                      <MenuItem key="3" value="100">
                        100
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel
                      className={!showPopup ? "input-long" : "input-short"}
                    >
                      Report Type
                      <div style={{ display: "inline-block", color: "red" }}>
                        *
                      </div>
                    </InputLabel>
                    <Select
                      labelId="report-type-select"
                      id="report-type-select"
                      label="report-type"
                      onChange={selectReportType}
                      style={{ minHeight: "37px" }}
                      value={reportType}
                    >
                      <MenuItem key="1" value="CSV">
                        CSV
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            sx={{
              height: "40px",
              marginLeft: "5px",
              marginTop: "20px",
              width: "96%",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
                <Box>
                  <FormControl className="custom-select" fullWidth>
                    <Box>
                      <TextField
                        className={
                          !showPopup
                            ? "input-long date-picker custom-select"
                            : "input-short date-picker custom-select"
                        }
                        id="datetime-local-end"
                        label="Start Date*"
                        type="date"
                        value={
                          startDateValue ? getDateString(startDateValue) : ""
                        }
                        onChange={changeStartDateValue}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1,
                          max: currDate.toISOString().slice(0, 10),
                        }}
                      />
                    </Box>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <FormControl className="custom-select" fullWidth>
                    <Box>
                      <TextField
                        className={
                          !showPopup
                            ? "input-long date-picker custom-select"
                            : "input-short date-picker custom-select"
                        }
                        id="datetime-local-end"
                        label="End Date*"
                        type="date"
                        value={endDateValue ? getDateString(endDateValue) : ""}
                        onChange={changeEndDateValue}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1,
                          min: getDateString(startDateValue),
                          max: currDate.toISOString().slice(0, 10),
                        }}
                      />
                    </Box>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <FormControl className="custom-select" fullWidth>
                    <Button
                      className="feature-config-btns"
                      //onClick={() => handleCalculateCostAccuracyReport()}
                      onClick={togglePopup}
                      variant="text"
                      sx={{
                        fontSize: "14px",
                        height: "33px",
                        marginTop: "-3px",
                        backgroundColor: "#2858D3",
                        color: "#FFFFFF",
                        fontFamily: "Poppins",
                        fontStyle: "normal",
                        fontWeight: "600",
                        "&:hover": {
                          backgroundColor: "rgba(1, 87, 255, 0.2)",
                        },
                      }}
                    >
                      CALCULATE COST
                    </Button>
                  </FormControl>
                </Box>
              </Grid>
              {loading && <div className="loader1"></div>}
            </Grid>
          </Box>
        </Box>
      </TabPanel>
      {showPopup && (
        <Popup
          show={showPopup}
          onClose={togglePopup}
          accountAndVersion={reportValue}
          sampleSize={sampleSize}
          reportType={reportType}
          startDate={startDateValue}
          endDate={endDateValue}
          handleCalculateCostAccuracyReport={handleCalculateCostAccuracyReport}
        />
      )}
    </div>
  );
};
export default withSnackbar(Reports);
